// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31MsI","requiredAsterisk":"Info_requiredAsterisk__ZIq3d"};